import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { Editor } from 'primeng/editor';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from "@angular/common/http";
import { PagenotfoundComponent } from './components/pagenotfound/pagenotfound.component';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { XiroccoConfirmationService } from './theme/xirocco-confirmation.service';
import { DatePipe } from '@angular/common';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ProgressSpinner } from 'primeng/progressspinner';
import { SupplierheatmpComponent } from './supplierheatmp/supplierheatmp.component';
import { OtheatmpComponent } from './otheatmp/otheatmp.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { Toast } from 'primeng/toast';
import { Select } from 'primeng/select';
import { XiroccoSelectDefaultsDirective } from './theme/xirocco-select-defaults.directive';
import { XiroccoDatepickerButtonBarDirective } from './theme/xirocco-datepicker-defaults.directive';
import { TabsModule } from 'primeng/tabs';
import { DialogService } from 'primeng/dynamicdialog';
import { HighchartsChartComponent, provideHighcharts } from 'highcharts-angular';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { LoaderComponent } from './components/loader/loader.component';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { providePrimeNG } from 'primeng/config';
import { XiroccoPreset } from './theme/xirocco-preset';
import { provideMarkdown } from 'ngx-markdown';
import Highcharts from 'highcharts/esm/highcharts';
import 'highcharts/esm/highcharts-more';
import 'highcharts/esm/modules/solid-gauge';
import 'highcharts/esm/modules/exporting';
import 'highcharts/esm/modules/export-data';
import 'highcharts/esm/modules/accessibility';

@NgModule({
  declarations: [
    AppComponent,
    PagenotfoundComponent,
    SupplierheatmpComponent,
    OtheatmpComponent,
    UnauthorizedComponent,
    LoaderComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    Editor,
    SharedModule,
    AppRoutingModule,
    ConfirmDialog,
    InfiniteScrollModule,
    ProgressSpinner,
    Toast,
    Select,
    XiroccoSelectDefaultsDirective,
    XiroccoDatepickerButtonBarDirective,
    TabsModule,
    HighchartsChartComponent,
    PdfJsViewerModule
  ],
  providers: [
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideHighcharts({
      instance: () => Promise.resolve(Highcharts),
    }),
    provideMarkdown(),
    providePrimeNG({
      overlayAppendTo: 'body',
      theme: {
        preset: XiroccoPreset,
        options: {
          // Staging uses light panels only; avoid OS dark mode on overlays
          darkModeSelector: false
        }
      }
    }),
    { provide: ConfirmationService, useClass: XiroccoConfirmationService },
    DialogService,
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
